import { render } from "./hr-tfn.vue?vue&type=template&id=70254a81"
import script from "./hr-tfn.vue?vue&type=script&lang=js"
export * from "./hr-tfn.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604161159/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__